import Selector from "./selector";

Selector.displayName = "ScheduleDateSelector";
export default Selector;
